import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import deTranslation from "@/locales/de/translation.json";
import frTranslation from "@/locales/fr/translation.json";
import enTranslation from "@/locales/en/translation.json";

const localeMap: Record<string, string> = {
    en: "en_US",
    de: "de_DE",
    fr: "fr_FR",
};

const options = {
    // order and from where user language should be detected
    order: ['cookie', 'querystring', 'navigator'],
    lookupCookie: 'frontend_lang',
    cookieOptions: { path: '/', sameSite: false },
    caches: ['cookie'],
    cookieDomain: '.relux.com',
    cookieMinutes: 365 * 24 * 60, // 1 year
    convertDetectedLanguage: (lng: string): string => {
        const short = lng.split("-")[0].split("_")[0].toLowerCase();
        return localeMap[short] || "en_US";
    },
};

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en_US: {
                translation: enTranslation,
            },
            fr_FR: {
                translation: frTranslation,
            },
            de_DE: {
                translation: deTranslation,
            },
        },
        fallbackLng: "en_US", // Fallback language if translation is missing
        interpolation: {
            escapeValue: false, // React already does escaping
        },
        detection: options
    });

export default i18n;
